module.exports = __webpack_public_path__ + "static/img/banner_desktop6.2e304058.jpg";